import * as appHelper from './appHelper';
import {TweenLite, Linear, Power0, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';


const Easing = Linear.easeIn; //Expo.easeInOut
const ScrollEasing = Linear.easeIn; //Expo.easeInOut

export function showHeight(params){

    if(appHelper.isObjectEleDefined(params.ele)){
        TweenLite.set(params.ele, {height: "auto"});
        if(appHelper.isObjectEleDefined(params.callback)) {
            TweenLite.from(params.ele, params.duration, {
                height: 0,
                ease: Easing,
                delay: params.delay,
            }).eventCallback("onComplete", params.callback);
        }else{
            TweenLite.from(params.ele, params.duration, {
                height: 0,
                delay: params.delay,
                ease: Easing
            });
        }
    }
}

export function hideHeight(params){
    if(appHelper.isObjectEleDefined(params.ele)){
        if(appHelper.isObjectEleDefined(params.callback)) {
            TweenLite.to(params.ele, params.duration, {
                height: 0,
                ease: Easing
            }).eventCallback("onComplete", params.callback);
        }else{
            TweenLite.to(params.ele, params.duration, {
                height: 0,
                ease: Easing
            });
        }
    }
}

export function rotate180(params){
    if(appHelper.isObjectEleDefined(params.ele)){
        if(appHelper.isObjectEleDefined(params.callback)) {
            TweenLite.to(params.ele, params.duration, {
                rotation: '+=' + 180 + 'deg',
                ease: Expo.easeOut
            }).eventCallback("onComplete", params.callback);
        }else{
            TweenLite.to(params.ele, params.duration, {
                rotation: '+=' + 180 + 'deg',
                ease: Expo.easeOut
            });
        }
    }
}

export function rotateTo(params){
    if(appHelper.isObjectEleDefined(params.ele)){
        if(appHelper.isObjectEleDefined(params.callback)) {
            TweenLite.to(params.ele, params.duration, {
                rotation: params.rotationAngle + 'deg',
                ease: Expo.easeOut,
                callback: params.callback,
                callbackParams: params.callbackParams,
            });
        }else{
            TweenLite.to(params.ele, params.duration, {
                rotation: params.rotationAngle + 'deg',
                ease: Expo.easeOut
            });
        }
    }
}


export function animateWidth(params){
    if(appHelper.isObjectEleDefined(params.ele)){
        if(appHelper.isObjectEleDefined(params.callback)) {
            TweenLite.to(params.ele, params.duration, {
                width: params.width,
                ease: Easing
            }).eventCallback("onComplete", params.callback);
        }else{
            TweenLite.to(params.ele, params.duration, {
                width: params.width,
                ease: Easing
            });
        }
    }
}

export function fadeIn(params){
    if(appHelper.isObjectEleDefined(params.ele)){
        TweenLite.set(params.ele, {opacity: 1});
        if(appHelper.isObjectEleDefined(params.callback)) {
            TweenLite.from(params.ele, params.duration, {
                opacity: 0,
                ease: Easing,
                delay: params.delay,
            }).eventCallback("onComplete", params.callback);
        }else{
            TweenLite.from(params.ele, params.duration, {
                opacity: 0,
                delay: params.delay,
                ease: Easing
            });
        }
    }
}

export function fadeOut(params){
    if(appHelper.isObjectEleDefined(params.ele)){
        if(appHelper.isObjectEleDefined(params.callback)) {
            TweenLite.to(params.ele, params.duration, {
                opacity: 0,
                ease: Easing
            }).eventCallback("onComplete", params.callback);
        }else{
            TweenLite.to(params.ele, params.duration, {
                opacity: 0,
                ease: Easing
            });
        }
    }
}

export function setClassName(params) {
    if(appHelper.isObjectEleDefined(params.ele)){
        if(appHelper.isObjectEleDefined(params.callback)) {
            TweenLite.to(params.ele, params.duration, {
                className: params.className,
            }).eventCallback("onComplete", params.callback);
        }else{
            TweenLite.to(params.ele, params.duration, {
                className: params.className,
            });
        }
    }
}

export function scrollTo(params) {
    if(appHelper.isObjectEleDefined(params.ele)){
        if(appHelper.isObjectEleDefined(params.callback)) {
            TweenLite.to(params.ele, params.duration, {
                scrollTop: params.scrollTop,
                ease: ScrollEasing
            }).eventCallback("onComplete", params.callback);
        }else{
            TweenLite.to(params.ele, params.duration, {
                scrollTop: params.scrollTop,
                ease: ScrollEasing
            });
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/helpers/animationHelper.js
 **/